import apiClient from '../../../../api/axios';

const BASE = '/v3/settlement/flight-log-recognitions';

export const flightLogRecognitionApi = {
    upload: (files) => {
        const formData = new FormData();
        files.forEach((file) => formData.append('files', file));
        return apiClient.post(BASE, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
        });
    },

    list: (params) => apiClient.get(BASE, { params }),

    detail: (id) => apiClient.get(`${BASE}/${id}`),

    signedUrl: (id) => apiClient.get(`${BASE}/${id}/signed-url`),

    review: (id, payload) => apiClient.put(`${BASE}/${id}/review`, payload),

    reExtract: (id) => apiClient.post(`${BASE}/${id}/re-extract`),

    // 重复单据去重：人工翻案——把该记录改选为去重主记录（清取代标记 + 复活 + 取代同组其余）
    dedupRestore: (id) => apiClient.post(`${BASE}/${id}/dedup-restore`),

    // 作废页：人工翻案「取消作废」——清 page_voided 标记 + 从 rejected 复活、重新参与对齐
    unvoid: (id) => apiClient.post(`${BASE}/${id}/unvoid`),

    remove: (id) => apiClient.delete(`${BASE}/${id}`),

    batchRemove: (ids) => apiClient.post(`${BASE}/batch-delete`, { ids }),

    checkExistence: (hashes) => apiClient.post(`${BASE}/check-existence`, { hashes }),

    exportFiltered: (params) => apiClient.post(`${BASE}/export-filtered`, params || {}),

    exportBatch: (ids) => apiClient.post(`${BASE}/export-batch`, { ids }),

    // S1：在役机队注册号（机号下拉选项）
    fleetOptions: () => apiClient.get(`${BASE}/fleet-options`),

    // S7：手动对齐/补全（当前筛选或指定 ids）
    reconcile: (payload) => apiClient.post(`${BASE}/reconcile`, payload || {}),

    exportSourceFiles: (ids) => apiClient.post(`${BASE}/export-source-files`, { ids }),

    // 识别重构：单字段模型预填采纳/撤回
    decideFieldAdjustment: (id, field, payload) =>
        apiClient.post(`${BASE}/${id}/field-adjustments/${encodeURIComponent(field)}/decision`, payload || {}),

    // 识别重构：重识别差异建议（含 _page_voided）采纳/驳回
    decideReextractSuggestions: (id, payload) =>
        apiClient.post(`${BASE}/${id}/reextract-suggestions/decision`, payload || {}),

    // 识别重构：提示词版本与线上监控、一键回滚、模型热切换（需 statistics:fuel:prompt_manage 权限）
    promptVersions: (domain) =>
        apiClient.get(`/v3/settlement/recognition-prompts/${encodeURIComponent(domain)}/versions`),

    updatePromptModel: (domain, payload) =>
        apiClient.put(`/v3/settlement/recognition-prompts/${encodeURIComponent(domain)}/model`, payload || {}),

    rollbackPromptVersion: (domain, payload) =>
        apiClient.post(`/v3/settlement/recognition-prompts/${encodeURIComponent(domain)}/rollback`, payload || {}),
};

export default flightLogRecognitionApi;

